import React, { useState } from "react";
import DateTime from "react-datetime";
import "react-datetime/css/react-datetime.css";

function TimeInput({ handleTimeChange, val }) {
  return (
    <div>
      <input type="time" className="form-control" placeholder="To" />
    </div>
  );
}

export default TimeInput;
